
import React from "react";

interface ResultsSummaryProps {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  itemCount: number;
  searchQuery: string;
}

const ResultsSummary: React.FC<ResultsSummaryProps> = ({
  currentPage,
  itemsPerPage,
  totalItems,
  itemCount,
  searchQuery
}) => {
  // For search results
  if (searchQuery) {
    return (
      <p className="text-muted-foreground mb-6">
        Showing {itemCount} results for "{searchQuery}"
      </p>
    );
  }
  
  // If we have zero items
  if (totalItems === 0) {
    return null;
  }
  
  // If we have prompts but no total count yet, show what we have
  if (itemCount > 0 && !totalItems) {
    return (
      <p className="text-muted-foreground mb-6">
        Showing {itemCount} prompts
      </p>
    );
  }
  
  // Calculate range being displayed
  const startItem = Math.max(1, (currentPage - 1) * itemsPerPage + 1);
  const endItem = Math.min((currentPage - 1) * itemsPerPage + itemCount, totalItems);
  
  return (
    <p className="text-muted-foreground mb-6">
      Showing {startItem}-{endItem} of {totalItems} prompts
    </p>
  );
};

export default ResultsSummary;
